import { Fragment, type ReactNode } from 'react';

/**
 * No-op error boundary used when no error reporter is registered.
 * Renders children directly; the `fallback` prop is ignored because errors
 * are not caught.
 */
export function PassthroughErrorBoundary({
  children,
}: {
  fallback: ReactNode;
  children?: ReactNode;
}) {
  return <Fragment>{children}</Fragment>;
}
